import yup from '@/libs/yup.ts';

export default yup.object({
    idn: yup.string().required('Idn is a required field').idn(),
    title: yup.string().flowTitle()
});
